import { render, staticRenderFns } from "./plan-user.vue?vue&type=template&id=1fac24d2"
import script from "./plan-user.vue?vue&type=script&lang=js"
export * from "./plan-user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports